module.exports = __webpack_public_path__ + "static/sav.banner-mosaic-primavera-verao-80e6e4bf168f29ebbc13649ab5756d98.jpg";